import { graphql } from '@e-socna/data-layer';

import { Loading } from '../../components/Loading';
import { NoData } from '../../components/Illustrations/NoData';
import { Versions as VersionsCmp } from '../../components/Versions';
import { useGraphQLQuery } from '../../hooks/useGraphQLQuery.hook';
import { useFolderReadyContext } from '../../contexts/FolderContext/hooks/useFolderReadyContext.hook';

export const FolderPage_Versions_FolderVersions_QueryDocument = graphql(`
  query FolderPage_Versions_FolderVersions_Query($originalId: Id!) {
    findAllFolderVersionsForOneOriginalId(originalId: $originalId) {
      _id
      createdAt
      creatorId
      automaticMemo
      internalMemo
      memo
      version {
        _id
        internalActors {
          _id
          categoryIds
          index
          isInternal
          kind
          thirdPartyId
          typeId
          ... on ActorOrganization {
            representatives {
              _id
              contextualRoleIds
              index
              personId
              typeIds
            }
            useItsEdmDomain
          }
          ... on ActorPerson {
            contextualRoleIds
          }
        }
        externalActors {
          _id
          categoryIds
          index
          isInternal
          kind
          thirdPartyId
          typeId
          ... on ActorOrganization {
            representatives {
              _id
              contextualRoleIds
              index
              personId
              typeIds
            }
            useItsEdmDomain
          }
          ... on ActorPerson {
            contextualRoleIds
          }
        }
        address {
          _id
          typeIds
          postalInfo {
            streetNumber
            route
            locality
            postalCode
            department
            region
            countryAlpha2
            building
            additional
            businessPostCode {
              postalCode
              distributorOfficeNumber
            }
            postOfficeBox
            inseeCode
          }
          locationInfo {
            coordinates
            projectionId
            altitude
            type
          }
          cadastralInfo {
            departmentCode
            municipalityCode
            oldMunicipalityCode
            districtCode
            section
            number
            sheet
          }
        }
        archiveInfo {
          _id
          endDateForAnalytics
          startDateForAnalytics
        }
        automaticMemo
        businessCreationDate
        businessCreatorId
        businessEventIds
        code
        codingConfig {
          _id
          kind
          strategyId
          ... on CodingConfigManual {
            code
          }
        }
        color
        createdAt
        creatorId
        description
        internalMemo
        isConfidential
        memo
        stateId
        title
        updatedAt
        updaterId
        workflowId
      }
    }
  }
`);

export const Versions = () => {
  const { folderId } = useFolderReadyContext();

  const { data, isSuccess } = useGraphQLQuery(
    FolderPage_Versions_FolderVersions_QueryDocument,
    { originalId: folderId },
    { enabled: !!folderId },
  );

  if (isSuccess) {
    const versions = data.findAllFolderVersionsForOneOriginalId;

    if (versions.length) {
      return <VersionsCmp versions={versions} />;
    }

    return <NoData />;
  }

  return <Loading />;
};
